import debounce from 'utils/debounce'

let lastPolledHeight = 0

const updateViewportHeight = () => {
  const doc = document.documentElement
  const height = Math.round(window.innerHeight)
  doc.style.setProperty('--app-height', `${height}px`)

  lastPolledHeight = height
}

const debouncedUpdateHeight = debounce(updateViewportHeight, 250)

const checkScaleChange = () => {
  const currentHeight = Math.round(window.innerHeight)

  if (currentHeight !== lastPolledHeight) {
    updateViewportHeight()
  }
}

window.addEventListener('resize', debouncedUpdateHeight)

if (window.orientation !== undefined) {
  window.addEventListener('orientationchange', debouncedUpdateHeight)
}

setInterval(checkScaleChange, 1000)

updateViewportHeight()

setTimeout(updateViewportHeight, 50)
